import { useCallback } from 'react';
import { type ShowModalOptions, useBillingContext, useUpgradeModal } from '@shared/scenes/billing';
import { i18n } from '@shared/util/i18n';

interface UploadSettings {
  showUpgradeModal?: boolean;
}

export const THREE_MB_IN_BYTES = 3145728;

export type ValidateFilesFn = <T extends { size: number }>(files: Array<T>) => Array<T | undefined>;

export function useValidateUploads({ showUpgradeModal }: UploadSettings) {
  const { billing } = useBillingContext();
  const { show: showModal } = useUpgradeModal();

  return useCallback<ValidateFilesFn>(
    files => {
      const filesResult = files.map(file => {
        if (billing.isPaidPlan === false && file.size > THREE_MB_IN_BYTES) {
          return undefined;
        }
        return file;
      });

      if (filesResult.some(result => result === undefined) && !!showUpgradeModal) {
        const modalOptions: ShowModalOptions = {
          title: i18n('card.blocks.image.upgradeModal.title'),
          description: i18n('card.blocks.image.upgradeModal.description'),
        };

        showModal(modalOptions);
      }

      return filesResult;
    },
    [showUpgradeModal, billing.isPaidPlan, showModal],
  );
}
